export default __webpack_public_path__ + "static/media/DSC_0606.aa6b99f8.JPG";